import React from "react";
import "../../../css/MonthPaid.css";
import mobility from "../../../img/ride.png";

interface MonthPaidProps {
  ThisMonth: number;
  LastMonth: number;
}

const MonthPaid = ({ ThisMonth, LastMonth }: MonthPaidProps) => {
  return (
    <div className="month_ride_container">
      <div className="month_ride_display">
        <img className="mobility" src={mobility} />
        <div className="month_ride_title">今月の支払金額</div>
      </div>
      <div className="month_ride_of">
        {ThisMonth.toLocaleString()} <span className="unit">円</span>
      </div>
      <div className="month_ride_last_month">
        先月の支払金額:
        <span className="month_ride_last_number">
          {LastMonth.toLocaleString()}
          <span className="unit">円</span>
        </span>
      </div>
    </div>
  );
};

export default MonthPaid;
